module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    staticStyle: {
      "background-color": "#f8f8f8"
    }
  }, [_c('el-container', {
    staticStyle: {
      "position": "relative",
      "width": "1240px",
      "height": "100%",
      "margin": "20px auto",
      "overflow": "hidden"
    }
  }, [_c('div', {
    ref: "asideFixedMenu",
    staticClass: "has-vertical-scrollerbar",
    staticStyle: {
      "transition": "all 0.2s",
      "width": "200px"
    },
    attrs: {
      "id": "asideFixedMenu"
    }
  }, [_c('el-menu', {
    staticStyle: {
      "border": "0 none",
      "padding-bottom": "80px"
    },
    attrs: {
      "collapse": _vm.isCollapsed,
      "mode": "vertical",
      "active-text-color": "#ffd04b",
      "default-openeds": ['1', '2', '3'],
      "router": ""
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-user"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.is_danwei == 1 ? '单位中心' : '个人中心'))])]), _vm._v(" "), _c('el-menu-item-group', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.is_danwei == 1 ? '单位中心' : '个人中心'))]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/updateinfo"
    }
  }, [_vm._v("资料修改")])], 1), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "财务"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/accountmanager"
    }
  }, [_vm._v("账户管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/orderlist"
    }
  }, [_vm._v("订单管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/payrecords"
    }
  }, [_vm._v("支付记录")])], 1)], 2), _vm._v(" "), (false) ? _c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-menu"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("业务管理")])]), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("文件网盘管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/openFileApply"
    }
  }, [_c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": "艺术导师报名"
    }
  }, [_vm._v("\n                文件上传\n              ")])], 1), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/openFileList"
    }
  }, [_vm._v("文件管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/kaojiFileApply"
    }
  }, [_vm._v(" 批量考级 ")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/kaojiFileList"
    }
  }, [_vm._v("批量考级管理")])], 2), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("投稿")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/tougao"
    }
  }, [_vm._v("投稿")])], 2), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("单位认证")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/institutecertificate"
    }
  }, [_vm._v("单位认证")])], 2) : _vm._e(), _vm._v(" "), _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("短视频和微电影剧本大赛")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/videoSaiApply"
    }
  }, [_vm._v("我要报名")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/videoSaiList"
    }
  }, [_vm._v("报名管理")])], 2), _vm._v(" "), (_vm.is_danwei == 2) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的考级")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/kaojiApplyList"
    }
  }, [_vm._v("考级管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的实训")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/shixunApplyList"
    }
  }, [_vm._v("实训管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的研学")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/yanxueApplyList"
    }
  }, [_vm._v("研学管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的国际交流")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/guojiApplyList"
    }
  }, [_vm._v("国际交流管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的竞赛培训")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/saishiApplyList"
    }
  }, [_vm._v("竞赛培训管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 2) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的校局长论坛")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/luntanApplyList"
    }
  }, [_vm._v("校局长论坛管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的全国艺术节")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/yishujieApplyList"
    }
  }, [_vm._v("全国艺术节管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 2) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的EAE人才库")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/rencaikuApplyList"
    }
  }, [_vm._v("EAE人才库管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 2) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的童星库")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/rencaikuApplyList21"
    }
  }, [_vm._v("童星库管理")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 2) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的错题")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/wrong-questions"
    }
  }, [_vm._v("错题集")])], 2) : _vm._e(), _vm._v(" "), (_vm.is_danwei == 1) ? _c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_vm._v("我的机构申请")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/danweiApplyList"
    }
  }, [_vm._v("机构管理")])], 2) : _vm._e()], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-container', [(false) ? _c('el-header', [_c('div', {
    class: ['header', {
      'has-tabs': _vm.meta.tabs
    }]
  }, [_c('div', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.meta.title))]), _vm._v(" "), (_vm.meta.tabs) ? _c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.meta.tabs), function(item) {
    return _c('el-tab-pane', {
      key: item.pathName,
      attrs: {
        "name": item.pathName
      }
    }, [_c('router-link', {
      attrs: {
        "slot": "label",
        "tag": "span",
        "to": {
          name: item.pathName
        }
      },
      slot: "label"
    }, [_vm._v(_vm._s(item.label) + "\n              ")])], 1)
  }), 1) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-main', [_c('keep-alive', {
    attrs: {
      "include": _vm.keepAliveInclude
    }
  }, [_c('router-view', {
    staticClass: "main-content"
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5d10a98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/MineLayout.vue
// module id = 1328
// module chunks = 0